import { useCallback } from "react"

import { useNavigate } from "react-router-dom"

import { ACCESS_TOKEN, REFRESH_TOKEN } from "../redux/constants"

export const useLogout = (options) => {
   const navigate = useNavigate()
   const { redirectTo = "/login", onLogout } = options || {}

   const handleLogout = useCallback(() => {
      // Remove access token
      localStorage.removeItem(ACCESS_TOKEN)
      localStorage.removeItem(REFRESH_TOKEN)
      localStorage.clear()

      // Optional callback before navigation
      onLogout?.()

      // Navigate to specified route
      navigate(redirectTo, { replace: true })
   }, [navigate, redirectTo, onLogout])

   return { handleLogout }
}
